module.exports = __webpack_public_path__ + "img/arroba_medellin_blanco.1679a6b9.svg";